import LeadForm from '../components/LeadForm.jsx';
import { WhatsAppGlyph, ArrowL } from '../components/Icons.jsx';
import SEO from '../components/SEO.jsx';
import useReveal from '../hooks/useReveal.js';
import { WA_URL } from '../config.js';
import { localBusinessSchema, organizationSchema } from '../data/schemas.js';

export default function Contact() {
  useReveal();
  return (
    <main className="contact-page">
      <SEO
        title="יצירת קשר"
        description="פוקוס מוד זמינה בוואטסאפ. תגובה תוך 48 שעות. גם בסופש."
        path="/contact"
        schema={[localBusinessSchema, organizationSchema]}
      />

      <section className="contact-hero">
        <div className="wrap">
          <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>יצירת קשר</div>
          <h1 className="contact-h1">
            3 משפטים.<br/>
            <span className="hl-block tilt-l">תשובה אמיתית</span>.
          </h1>
          <p className="contact-lede pre">{'פוקוס מוד זמינה בוואטסאפ.\nתגובה תוך 48 שעות.\nגם בסופ״ש.'}</p>
        </div>
      </section>

      <section className="contact-grid-wrap">
        <div className="wrap">
          <div className="contact-grid">
            <a className="contact-card contact-card-wa reveal" href={WA_URL} target="_blank" rel="noopener noreferrer">
              <div className="contact-card-icon"><WhatsAppGlyph size={28} /></div>
              <h3 className="contact-card-title">וואטסאפ</h3>
              <div className="contact-card-num" dir="ltr">052-410-6717</div>
              <p className="contact-card-body pre">{'הדרך הכי מהירה.\n3 משפטים: מה העסק, מה תקוע, מה הצעד הבא.'}</p>
              <span className="contact-card-cta">לוואטסאפ <ArrowL size={14} /></span>
            </a>

            <a className="contact-card reveal" href="mailto:yoav@focusmode.info">
              <div className="contact-card-icon contact-card-icon-mail">@</div>
              <h3 className="contact-card-title">מייל</h3>
              <div className="contact-card-num" dir="ltr">yoav@focusmode.info</div>
              <p className="contact-card-body pre">{'לתוכניות יותר ארוכות.\nלמקרים שצריך לצרף קבצים.'}</p>
              <span className="contact-card-cta">למייל <ArrowL size={14} /></span>
            </a>
          </div>

          <article className="contact-formwrap reveal">
            <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>טופס השארת פרטים</div>
            <h3 className="contact-formwrap-h pre">{'לא רוצים וואטסאפ?\nהשאירו פרטים כאן.'}</h3>
            <p className="contact-formwrap-sub pre">{'אפשר לבחור כמה שירותים.\nלא צריך לדעת בדיוק מה צריך.'}</p>
            <LeadForm />
          </article>

          <div className="contact-meta reveal">
            <div className="contact-meta-cell">
              <div className="contact-meta-label">שעות עבודה</div>
              <div className="contact-meta-val pre">{'א׳–ה׳\n10:00–18:00'}</div>
            </div>
            <div className="contact-meta-cell">
              <div className="contact-meta-label">זמן תגובה</div>
              <div className="contact-meta-val pre">{'עד 48 שעות.\nבד״כ הרבה פחות.'}</div>
            </div>
            <div className="contact-meta-cell">
              <div className="contact-meta-label">מיקום</div>
              <div className="contact-meta-val pre">{'גבעת השלושה.\nעובדים עם לקוחות בכל הארץ.'}</div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
